import api from 'config/api'

const Api = api(`${process.env.REACT_APP_API_URL}`)

export default Api
